import { Row } from '@tanstack/react-table';
import { ReactNode } from 'react';

import { TableRow } from '../Table';
import { GridCell } from './GridCell';

interface CoreGridRowProps<TData> {
    row: Row<TData>;
    onClick: any;
    wrapContent?: boolean;
    selected: boolean;
    enableRowSelection?: boolean;
    hasPadding?: boolean;
    cellClassName?: string;
    /**
     * Optional wrapper applied around this row's cells. When provided, the
     * returned node is rendered instead of the raw cell list, so the caller
     * can e.g. mount a `<FormProvider>` scoped to a single row without
     * paying that cost on every other row.
     */
    rowWrapper?: (row: Row<TData>, children: ReactNode) => ReactNode;
}

const CoreGridRow = <TData,>({ row, onClick, selected, wrapContent, enableRowSelection = true, hasPadding = false, cellClassName, rowWrapper }: CoreGridRowProps<TData>) => {

    const cells = row.getVisibleCells().map((cell) => (
        <GridCell
            key={cell.id}
            cell={cell}
            wrapContent={wrapContent}
            hasPadding={hasPadding}
            cellClassName={cellClassName}
        />
    ));

    return (
        <TableRow
            key={row.id}
            data-state={row.getIsSelected() && 'selected'}
            onClick={onClick}
            selected={selected}
            className={`grid-row ${!enableRowSelection ? 'no-row-selection' : ''}`}
        >
            {rowWrapper ? rowWrapper(row, cells) : cells}
        </TableRow>
    );
};

export { CoreGridRow as GridRow };
